import { API, graphqlOperation } from 'aws-amplify';
//import { createCompany, updateCompany, deleteCompany } from './graphql/mutations';
//import { listCompanys } from './graphql/queries';

export default {
    namespaced:true,
    state: {
        list: null,
        item: null,
        nextToken: null,
    },
    mutations: {
        list: (state, payload) => { state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value },
        item: (state, payload) => { state.item = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value }
    },
    getters: {
       
    },
    actions: {
        async get(context, payload) {
            const v = await API.graphql(graphqlOperation(`query GetProduct($id: ID!) {
              getProduct(id: $id) {
                id
                url
                name
                popularity
              }
            }
            `, { id: payload.id }));
            
            context.commit('item', {value: v.data.getProduct });

        },
        
        async list(context, payload) {
          //console.dir(payload);
          const c = await API.graphql(graphqlOperation(`
          query productsByDomainPopularity(
            $domainID: ID
            $popularity: ModelIntKeyConditionInput
            $sortDirection: ModelSortDirection
            $filter: ModelProductFilterInput
            $limit: Int
            $nextToken: String
          ) {
            productsByDomainPopularity(
              domainID: $domainID
              popularity: $popularity
              sortDirection: $sortDirection
              filter: $filter
              limit: $limit
              nextToken: $nextToken
            ) {
              items {
                id
                url
                name
                popularity
              }
              nextToken
            }
          }
          `, payload ));
          context.commit('list', {value: c.data.productsByDomainPopularity.items, append: true });
          context.commit('nextToken', {value: c.data.productsByDomainPopularity.nextToken });
        },

    }
}